module.exports = __webpack_public_path__ + "img/Journalisma4.e85c7581.png";